import PromocodeRewardStructure from '@/datatypes/promocode/reward-structure';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default class PromocodeCampaign {
  public id: string;
  public title: string;
  public permalink: string;
  public keyGenerator: string;
  public algorithm: string;
  public active: boolean;
  public rewardStructure: PromocodeRewardStructure;
  public includesCodeInUrl: boolean;

  constructor(options) {
    this.id = options.id;
    this.title = options.title;
    this.permalink = options.permalink;
    this.keyGenerator = options.keyGenerator;
    this.algorithm = options.algorithm;
    this.active = options.active;
    this.includesCodeInUrl = options.includesCodeInUrl;
    if (options.rewardStructure) {
      this.rewardStructure = new PromocodeRewardStructure(
        camelcaseKeysDeep(options.rewardStructure),
      );
    } else {
      this.rewardStructure = new PromocodeRewardStructure({});
    }
  }
}
